import React, { Component } from 'react'
import { Table } from 'react-bootstrap'
import Api from '../../../Global/Modules/Api'

class KennisIncompany extends Component {
    constructor(props) {
        super(props)
        this.getMeetings = this.getMeetings.bind(this)
        this.getTotalPoints = this.getTotalPoints.bind(this)
    }

    getMeetings() {
        let data = this.props.data
        return data && data.length > 0 ? data.map((l, index) => {
            return <tr key={index}>
                <td>{l.institution}</td>
                <td>{l.typeInCompany}</td>
                <td>{l.name}</td>
                <td>{l.hours}</td>
                <td>{l.date}</td>
                <td>{l.points}</td>
            </tr>
        }) : null
    }

    getTotalPoints() {
        let data = this.props.data
        return data && data.length > 0 ?
            <tr>
                <td colSpan='5'><strong>Totaal ke´s</strong></td>
                <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
            </tr> : null
    }

    render() {
        return (
            <div className="rapport">
                <h5><strong>{this.props.permanent ? "Permanente Incompany kennisoverdracht" : "Incompany kennisoverdracht"}</strong></h5>
                <Table responsive bordered className="IncompanyKennisoverdracht">
                    <thead>
                        <tr>
                            <th>Naam bedrijf</th>
                            <th>Deelname</th>
                            <th>Naam bijeenkomst</th>
                            <th>Uren</th>
                            <th>Datum</th>
                            <th>Ke's</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.getMeetings()}
                        {this.getTotalPoints()}
                    </tbody>
                </Table>
            </div>)

    }
}

export default KennisIncompany


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/KennisIncompany.js